import { DirectiveOptions } from "vue";

/// declare variable which is defined in DefinePlugin definition in webpack.config.js
declare const PUBLIC_PATH: string;

const PUBLIC_PATH_STRING = "PUBLIC_PATH";

/* This directive allows developer to use PUBLIC_PATH variable in vue templates in cases where i4U
 * is not installed in the root folder of public domain (eg. https://this.is.domain/not-root/). 
 * Usage:
 * 
 * Register this directive to Vue in entrypoint:
 * import { PublicPathReplacerDirective } from "@/Scripts/vue-directives/publicpath-replacer"
 * 
 * Vue.directive("public-path-replacer", PublicPathReplacerDirective);
 * 
 * Use in Vue template:
 * <form method="post" v-public-path-replacer:action="'PUBLIC_PATHNewContract/Contract/Contract'">
 */
export const PublicPathReplacerDirective: DirectiveOptions = {
    inserted(el, binding, vnode, prevVnode) {
        if (el != null) {
            const newValue = binding.value.replace(PUBLIC_PATH_STRING, PUBLIC_PATH);

            el.setAttribute(binding.arg, newValue);
        }
    }
}